import React from "react";
import styled from "styled-components";
import DidYouKnowInline from "./DidYouKnowInline";

export default function DidYouKnow() {
  return (
    <Wrapper aria-label="Did you know">
      <div className="lightBg" style={{ padding: "20px 0 0 0" }}>
        <div className="container">
          <DidYouKnowInline
            body="Lawyers can spend up to 40% of their time searching for information—not practicing law."
            imageSrc="/didyouknow.png"
            imageAlt="Lawyer surprised by time lost searching for information"
          />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  margin-bottom: -6px;
`;